import {getDeviceByPublicPlaceId, getPublicPlace,postPublicPlace,deletePublicPlace,putPublicPlace } from '../../../api/eastCoastDataApi/publicPlaceApi'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'

const state = {
    allPublicPlace:[],
    publicPlaceData:[],
    publicPlaceDevice: []
}

const getters = {
  getAllPublicPlace: (state) => {
    return state.allPublicPlace
  },

  getPublicPlaceData: (state) => (condition = {}) => {
    if(Utils.isEmptyObject(condition) || condition[CONST.EAST_COAST_PUBLIC_PLACE_KEY.SCENIC_AREA_ID] < 0) {
        return state.publicPlaceData
    }

    return state.publicPlaceData.filter(place =>{
        return place[CONST.EAST_COAST_PUBLIC_PLACE_KEY.SCENIC_AREA_ID] === condition[CONST.EAST_COAST_PUBLIC_PLACE_KEY.SCENIC_AREA_ID]
    })
  },

  getPublicPlaceDevice: (state) => (deviceType = '') => {
    if(Utils.isEmptyObject(deviceType)) {
        return state.publicPlaceDevice
    }  

    return state.publicPlaceDevice.filter(device => {
        return device.operationType === deviceType
    })  
    
  }

}

const actions = {
  async getPublicPlace({ commit }, condition) {
      commit('publicPlaceData', await getPublicPlace(condition))
    },

  async getDeviceByPublicPlaceId({commit}, condition) {
     commit('publicPlaceDevice', await getDeviceByPublicPlaceId(condition))
  }  ,

  
  async postPublicPlace({ commit }, condition) {
    const result = await postPublicPlace(condition)
    if (result.success) {
      commit('updatePublicPlace', { data: condition, mode: 'post' })
    }

    return result
  },

  async putPublicPlace({ commit }, condition) {
    const result = await putPublicPlace(condition)
  
    if (result.success) {
      commit('updatePublicPlace', { data: condition, mode: 'put' })
    }

    return result
  },

  async deletePublicPlace({ commit }, publicPlaceId) {
    const result = await deletePublicPlace(publicPlaceId)
    if (result.success) {
      commit('updatePublicPlace', { data: publicPlaceId, mode: 'delete' })
    }

    return result
  }
}

const mutations = {
    publicPlaceData(state, data) {
        if(Utils.isEmptyObject(data) || Utils.isEmptyObject(data.publicPlaceData)) {
            return 
        }

        if(Utils.isEmptyString(data.placeType)) {
            state.allPublicPlace = data.publicPlaceData
            state.publicPlaceData = data.publicPlaceData
        } else {
            state.publicPlaceData[data.placeType] = data.publicPlaceData
        }
    
    },

    publicPlaceDevice(state, data) {
      if(Utils.isEmptyObject(data)) {
        state.publicPlaceDevice = [] 
      }

      state.publicPlaceDevice = data
  },



    updatePublicPlace(state, { data, mode }) {
      switch (mode) {
        case 'post':
          state.allPublicPlace.push(data)
          break
        
        case 'put':
          let target = state.allPublicPlace.find(d => d.id === data.id)
          target = data
          break
    
        case 'delete' :
          state.allDevice = state.allPublicPlace.filter(d => d.id !== data)
          break    
      }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }